import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { deleteListSettings } from '../../../actions/siteadmin/deleteListSettings';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';

import ImageUploadComponent from '../../Common/ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';

import update from './update';
import validate from './validate';
import messages from '../../../locale/messages';
import { amenitiesUploadDir } from '../../../config';
import { photosShow } from '../../../helpers/photosShow';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './ListSettingsForm.css';
import bt from '../../../components/commonStyle.css';

class EditListSettingsForm extends Component {

  static propTypes = {
    isEnable: PropTypes.string,
    id: PropTypes.number,
    typeId: PropTypes.number,
    fieldType: PropTypes.string,
    deleteListSettings: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      fieldType: null
    }
  }

  UNSAFE_componentWillMount() {
    const { fieldType } = this.props;
    if (fieldType != undefined) {
      this.setState({ fieldType: fieldType });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { fieldType } = nextProps;
    if (fieldType != undefined) {
      this.setState({ fieldType: fieldType });
    }
  }


  handleChange = async () => {
    const { change } = this.props;
    await change('image', null)
  }

  success = async (file, fromServer) => {
    const { change, demoRestriction } = this.props
    let fileName = fromServer.file.filename;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    change('image', fileName)
  }

  handleDelete = async (id, typeId, page) => {
    const { deleteListSettings, adminListSettings, demoRestriction } = this.props;
    let currentPage = page > 1 && adminListSettings?.getAllAdminListSettings?.listSettingsData?.length == 1 ? page - 1 : page;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await deleteListSettings(id, typeId, currentPage)
  }

  handleUpdate = async (values, dispatch) => {
    const { page, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await update(values, dispatch, page)
  }

  render() {
    const { error, handleSubmit, submitting, roomTypeLoader2 } = this.props;
    const { formatMessage } = this.props.intl;
    const { id, typeId, deleteListSettings, image, page } = this.props;
    const { fieldType } = this.state;
    let path = photosShow(amenitiesUploadDir);
    return (
      <div className={cx(s.formMaxWidth, 'maxwidthcenter', 'adminRadioBtn')}>
        <form onSubmit={handleSubmit(this.handleUpdate)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <FormGroup className={s.space3}>
            <Field
              name="itemName"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.addItemNew)}
              inputClass={cx(bt.commonControlInput)}
              formGroupClass={bt.space4}
              placeholder={formatMessage(messages.itemNamePlaceHolder)}
            />
          </FormGroup>
          {
            (typeId === 11 || typeId === 10 || typeId === 12 || typeId === 1 || typeId === 3) &&

            <div className={bt.space4}>
              <p className={s.labelTextNew}><FormattedMessage {...messages.IconLabel} /></p>
              <div className={bt.picContainerMain}>
                <div className={cx(bt.picContainer)}>
                  <p className={cx('hidden-md hidden-lg hidden-sm')}>&nbsp;</p>
                  <CommonImageDisplay
                    loader={roomTypeLoader2}
                    image={path + image}
                    isDelete={true}
                    isDefaultPic={image ? false : true}
                    deleteImage={this.handleChange}
                  />
                </div>
              </div>

              <div className={s.spaceTop2}>
                <div className={cx(s.fullWidth, bt.btnPrimary, s.noPadding, 'photoUploadBtn')}>
                  <ImageUploadComponent
                    defaultMessage={formatMessage(messages.UploadImage)}
                    componentConfig={{
                      iconFiletypes: ['.jpg', '.png', '.jpeg'],
                      multiple: false,
                      showFiletypeIcon: false,
                      postUrl: '/uploadAmenities'
                    }}
                    loaderName={'roomTypeLoader2'}
                    success={this.success}
                  />
                </div>
              </div>
            </div>

          }
          {
            fieldType == "numberType" && <div>
              <Field
                name="otherItemName"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.addOtherItem)}
                inputClass={bt.commonControlInput}
                formGroupClass={bt.space4}
                placeholder={formatMessage(messages.otherItemPlaceHolder)}
              />
              <Field
                name="startValue"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.startValue)}
                inputClass={bt.commonControlInput}
                formGroupClass={bt.space4}
                maxLength={5}
                placeholder={formatMessage(messages.startValuePlaceHolder)}
              />
              <Field
                name="endValue"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.endValue)}
                inputClass={bt.commonControlInput}
                formGroupClass={bt.space4}
                maxLength={5}
                placeholder={formatMessage(messages.endValuePlaceHolder)}
              />
            </div>
          }
          {
            fieldType != "numberType" &&
            <div>
              <FormGroup className={bt.space4}>
                <div className='commonRadioBtnFlexGroup'>
                  <label className={cx(s.labelTextNew, bt.cursorPointer, 'commonRadioFlex')}>
                    <Field name="isEnable"
                      component="input"
                      type="radio" value="1" />
                    <span className={s.radioBtn}>{formatMessage(messages.enable)}</span>
                  </label>
                  <label className={cx(s.labelTextNew, bt.cursorPointer, 'commonRadioFlex')}>
                    <Field name="isEnable" component="input" type="radio" value="0" /> <span className={s.radioBtn}>{formatMessage(messages.disable)}</span>
                  </label>
                </div>
              </FormGroup>
              <FormGroup className={bt.space4}>
                <div className='doubleBtnFlexEnd'>
                  <Button className={cx(bt.btnPrimary, s.btnWidth)} type="submit" disabled={submitting}>
                    {formatMessage(messages.update)}
                  </Button>
                  <Button className={cx(bt.btnPrimaryBorder, s.btnWidth)} onClick={() => this.handleDelete(id, typeId, page)} disabled={submitting}>
                    {formatMessage(messages.delete)}
                  </Button>
                </div>
              </FormGroup>
            </div>
          }
          {
            fieldType === "numberType" &&
            <div className='singleButtonFlexEnd'>
              <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting}>
                {formatMessage(messages.update)}
              </Button>
            </div>
          }
        </form>
      </div>
    )
  }

}

EditListSettingsForm = reduxForm({
  form: "EditListSettingsForm",
  validate
})(EditListSettingsForm);

const selector = formValueSelector("EditListSettingsForm");

const mapState = (state) => ({
  isEnable: selector(state, 'isEnable'),
  id: selector(state, 'id'),
  typeId: selector(state, 'typeId'),
  image: selector(state, 'image'),
  roomTypeLoader2: state?.loader?.roomTypeLoader2,
  adminListSettings: state?.adminListSettingsData?.data,
  page: state?.adminListSettingsData?.currentPage
});

const mapDispatch = {
  deleteListSettings,
  change,
  demoRestriction
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(EditListSettingsForm)));